// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BNmI0","footer":"styles_footer__Tl6F3","passCodeTooltip":"styles_passCodeTooltip__2oXzB"};